import { render, staticRenderFns } from "./ConfigAlarmCode.vue?vue&type=template&id=5e0b3daf&scoped=true&"
import script from "./ConfigAlarmCode.vue?vue&type=script&lang=ts&"
export * from "./ConfigAlarmCode.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigAlarmCode.vue?vue&type=style&index=0&id=5e0b3daf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0b3daf",
  null
  
)

export default component.exports